export enum TurnedTextFormatKinds {
  None = 0,
  Asterisk = 1,
  Dot = 2,
}
